import { render, staticRenderFns } from "./AlertNotificationsPage.vue?vue&type=template&id=b46b63e2"
import script from "./AlertNotificationsPage.vue?vue&type=script&lang=js"
export * from "./AlertNotificationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports